<span
  class="app-icon"
  [class]="sizeClass"
  [ngClass]="colorClass"
  [style.width]="customSize"
  [style.height]="customSize"
  [style.color]="inlineColor"
  [innerHTML]="svgContent"
  [attr.aria-label]="ariaLabel"
  [attr.role]="role">
</span>
